document.addEventListener('DOMContentLoaded', function () {

  // ── Cart count ─────────────────────────────
  function updateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(function(cart) {
        document.querySelectorAll('.nav-cart').forEach(function(btn) {
          btn.textContent = '🛒 Cart (' + cart.item_count + ')';
        });
      });
  }

  updateCartCount();

  // ── Toast ──────────────────────────────────
  function showCartToast() {
    var toast = document.getElementById('cart-toast');
    if (!toast) return;
    toast.classList.add('show');
    setTimeout(function() { toast.classList.remove('show'); }, 3000);
  }

  // ── Add to cart — product page only ────────
  var addToCartBtn = document.querySelector('.add-to-cart-btn');
  if (addToCartBtn) {
    var productForm = addToCartBtn.closest('form');
    if (productForm) {
      productForm.addEventListener('submit', function(e) {
        e.preventDefault();
        var variantId = parseInt(document.getElementById('selected-variant-id').value);
        var qtyInput  = document.getElementById('qty-input');
        var maxQty    = (typeof variantInventory !== 'undefined' && variantInventory[variantId])
                        ? variantInventory[variantId] : 999;
        var qty = Math.min(parseInt(qtyInput ? qtyInput.value : 1), maxQty);
        if (qtyInput) qtyInput.value = qty;

        addToCartBtn.textContent = 'Adding...';
        addToCartBtn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        })
        .then(function() {
          addToCartBtn.textContent = '✓ Added to Cart!';
          updateCartCount();
          showCartToast();
          setTimeout(function() {
            addToCartBtn.textContent = 'Add to Cart';
            addToCartBtn.disabled = false;
          }, 2500);
        })
        .catch(function() {
          addToCartBtn.textContent = 'Error — Try Again';
          addToCartBtn.disabled = false;
        });
      });
    }
  }

  // ── Cart page qty buttons ───────────────────
  if (document.querySelector('.cart-item')) {

    // Global queue — ensures requests fire one at a time in order
    var cartQueue = Promise.resolve();

    function updateLineItem(lineKey, newQty, inputEl) {
      // Queue each request — waits for previous to finish before sending
      cartQueue = cartQueue.then(function() {
        if (inputEl) inputEl.classList.add('updating');
        return fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: lineKey, quantity: newQty })
        })
        .then(r => r.json())
        .then(function(cart) {
          if (inputEl) inputEl.classList.remove('updating');
          if (newQty === 0) {
            window.location.reload();
          } else {
            // Update nav count from response directly — no extra fetch needed
            document.querySelectorAll('.nav-cart').forEach(function(btn) {
              btn.textContent = '🛒 Cart (' + cart.item_count + ')';
            });
          }
        })
        .catch(function() {
          if (inputEl) inputEl.classList.remove('updating');
        });
      });
      return cartQueue;
    }

    document.querySelectorAll('.cart-item').forEach(function(item) {
      var minusBtn  = item.querySelector('.cart-qty-minus');
      var plusBtn   = item.querySelector('.cart-qty-plus');
      var input     = item.querySelector('.cart-qty-input');
      var removeBtn = item.querySelector('.cart-remove');
      if (!input) return;

      var lineKey = input.dataset.lineKey;
      var maxQty  = parseInt(input.dataset.max) || 999;
      // Debounce timer — batches rapid taps into one request
      var debounceTimer = null;
      var pendingQty = null;

      function refreshButtons() {
        var qty = parseInt(input.value) || 0;
        if (minusBtn) minusBtn.disabled = qty <= 1;
        if (plusBtn) {
          plusBtn.disabled = qty >= maxQty;
          plusBtn.classList.toggle('at-max', qty >= maxQty);
        }
      }

      refreshButtons();

      function scheduleUpdate(qty) {
        pendingQty = qty;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function() {
          updateLineItem(lineKey, pendingQty, input);
        }, 300); // Wait 300ms after last tap before sending
      }

      if (minusBtn) {
        minusBtn.addEventListener('click', function() {
          var qty = Math.max(0, parseInt(input.value) - 1);
          input.value = qty; // Update display instantly
          refreshButtons();
          scheduleUpdate(qty);
        });
      }

      if (plusBtn) {
        plusBtn.addEventListener('click', function() {
          var current = parseInt(input.value) || 0;
          if (current >= maxQty) {
            var warn = item.querySelector('.cart-stock-max');
            if (warn) { warn.classList.add('show'); setTimeout(function() { warn.classList.remove('show'); }, 2500); }
            return;
          }
          var qty = current + 1;
          input.value = qty; // Update display instantly
          refreshButtons();
          scheduleUpdate(qty);
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', function() {
          clearTimeout(debounceTimer);
          updateLineItem(lineKey, 0, input);
        });
      }
    });
  }

});
